import { createRouter, createWebHistory } from "vue-router";
import Signin from "@/views/public/Signin.vue";
import Signup from "@/views/public/Signup.vue";
import ForgotPassword from "@/views/public/ForgotPassword.vue";
import Profile from "@/views/common/Profile.vue";

import PasswordReset from "@/views/public/PasswordReset.vue";
import PlanDetails from "@/views/public/PlanDetails.vue";

import store from "@/store";
import StoreClaimDetails from "@/views/store/claim/details/StoreClaimDetails";

import PlanSales from "@/views/common/PlanSales.vue";
import Invoices from "@/views/admin/billing/Invoices.vue";
import InvoiceDetails from "@/views/admin/billing/InvoiceDetails.vue";
import RetributionConfigurations from "@/views/admin/retribution/RetributionConfigurations.vue";
import Retributions from "@/views/admin/retribution/Retributions.vue";
import ClaimList from "@/views/common/claim/ClaimList.vue";
import AdminClaimDetails from "@/views/admin/claim/details/AdminClaimDetails";
import OrganizationDetails from "@/views/admin/organization/OrganizationDetails.vue";
import StoreList from "@/views/admin/organization/StoreList.vue";

import Subscription from "@/views/pos/Subscription.vue";
import Home from "@/views/pos/Home.vue";
import ProductList from "@/views/store/products/list/ProductList.vue";
import ProductDetails from "@/views/store/products/details/ProductDetails.vue";
import PosClaimDetails from "@/views/pos/claim/details/PosClaimDetails.vue";
import Leads from "@/views/pos/leads/Leads.vue";
import SellerList from "@/views/pos/seller/SellerList.vue";
import PlanSaleDetails from "@/views/common/PlanSaleDetails.vue";
import StoreDetails from "@/views/admin/store/StoreDetails.vue";
import UserList from "@/views/admin/user/UserList.vue";
import PosChallengeList from "@/views/pos/challenge/ChallengeList.vue";
import PosCurrentChallenge from "@/views/pos/challenge/CurrentChallenge.vue";
import PosRetributions from "@/views/pos/retributions/Retributions.vue";
import PosRetributionsGrid from "@/views/pos/retributions/RetributionsGrid.vue";
import ChallengeList from "@/views/admin/challenge/ChallengeList.vue";
import CurrentChallenge from "@/views/admin/challenge/CurrentChallenge.vue";
import AdminTraining from "@/views/admin/training/Training.vue";
import OrganizationAnalytics from "@/views/public/OrganizationAnalytics.vue";
import AdminClaimInvoices from "@/views/admin/claim/AdminClaimInvoices.vue";
import PosClaimInvoices from "@/views/pos/claim/invoices/PosClaimInvoices.vue";
import StoreClaimInvoices from "@/views/store/claim/invoices/StoreClaimInvoices.vue";
import ContractDistributions from "@/views/common/contract_distributions/ContractDistributions.vue";
import ContractDistributionDetails from "@/views/common/contract_distributions/ContractDistributionDetails.vue";
import RoadmapOverview from "@/views/common/RoadmapOverview.vue";
import AdminHome from "@/views/admin/analytics/AdminHome.vue";
import GeneralAnalytics from "@/views/admin/analytics/GeneralAnalytics.vue";
import RetailAnalyticsView from "@/views/admin/analytics/RetailAnalyticsView.vue";
import RegionAnalyticsView from "@/views/admin/analytics/RegionAnalyticsView.vue";
import PosPilotage from "@/views/pos/PosPilotage.vue";
import PosTraining from "@/views/pos/training/Training.vue";
import Quiz from "@/views/pos/training/Quiz.vue";
const TrainingModule = () => import("@/views/pos/training/TrainingModule.vue");
import { NotFound } from "@estaly/ui";

import posthog from "posthog-js";
import { identifyPosthogUser } from "@/utils/posthog";

const publicRoutes = [
  {
    path: "/signin",
    component: Signin,
  },

  {
    path: "/signup",
    component: Signup,
  },

  {
    path: "/forgot-password",
    component: ForgotPassword,
  },

  {
    path: "/password-reset/:id",
    component: PasswordReset,
  },

  {
    path: "/plan-details/:contractSku",
    component: PlanDetails,
  },

  {
    path: "/analytics",
    component: OrganizationAnalytics,
  },

  {
    path: "/404",
    component: NotFound,
  },
];

const adminRoutes = [
  {
    path: "/admin/home",
    component: AdminHome,
    meta: {
      layout: "admin-layout",
      navigation: "Home",
      permission: "admin",
    },
  },
  {
    path: "/admin/analytics/general",
    component: GeneralAnalytics,
    meta: {
      layout: "admin-layout",
      navigation: "Home",
      permission: "admin",
    },
  },
  {
    path: "/admin/analytics/retail",
    component: RetailAnalyticsView,
    meta: {
      layout: "admin-layout",
      navigation: "Retail analytics",
      permission: "admin",
    },
  },
  {
    path: "/admin/analytics/retail/regions",
    component: RegionAnalyticsView,
    meta: {
      layout: "admin-layout",
      navigation: "Region analytics",
      permission: "admin",
    },
  },
  {
    path: "/admin/roadmap",
    component: RoadmapOverview,
    meta: {
      layout: "admin-layout",
      navigation: "Roadmap",
      permission: "admin",
    },
  },
  {
    path: "/admin/plan-sales",
    component: PlanSales,
    meta: {
      layout: "admin-layout",
      navigation: "Plan sales",
      permission: "plan_sales",
    },
  },
  {
    path: "/admin/plan-sales/:id",
    component: PlanSaleDetails,
    meta: {
      layout: "admin-layout",
      navigation: "Plan sales",
      permission: "plan_sales",
    },
  },
  {
    path: "/admin/claims",
    component: ClaimList,
    meta: {
      layout: "admin-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/admin/claims/:id",
    component: AdminClaimDetails,
    meta: {
      layout: "admin-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/admin/profile",
    component: Profile,
    meta: { layout: "admin-layout" },
  },
  {
    path: "/admin/claim_invoices",
    component: AdminClaimInvoices,
    meta: {
      layout: "admin-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/admin/billing/invoices",
    component: Invoices,
    meta: {
      layout: "admin-layout",
      navigation: "Remuneration",
      permission: "invoices",
    },
  },
  {
    path: "/admin/billing/invoices/:id",
    component: InvoiceDetails,
    meta: {
      layout: "admin-layout",
      navigation: "Remuneration",
      permission: "invoices",
    },
  },
  {
    path: "/admin/retribution-configurations",
    component: RetributionConfigurations,
    meta: {
      layout: "admin-layout",
      navigation: "Retributions",
      permission: "invoices",
    },
  },
  {
    path: "/admin/retributions",
    component: Retributions,
    meta: {
      layout: "admin-layout",
      navigation: "Retributions",
      permission: "retributions",
    },
  },
  {
    path: "/admin/organization/details",
    component: OrganizationDetails,
    meta: {
      layout: "admin-layout",
      navigation: "My organization",
      permission: "stores",
    },
  },
  {
    path: "/admin/organization/stores",
    component: StoreList,
    meta: {
      layout: "admin-layout",
      navigation: "My organization",
      permission: "stores",
    },
  },
  {
    path: "/admin/organization/stores/:id",
    component: StoreDetails,
    meta: {
      layout: "admin-layout",
      navigation: "Stores",
      permission: "stores",
    },
  },
  {
    path: "/admin/users",
    component: UserList,
    meta: {
      layout: "admin-layout",
      navigation: "Users",
      permission: "users",
    },
  },
  {
    name: "CurrentChallenge",
    path: "/admin/challenge/current-challenge",
    component: CurrentChallenge,
    meta: {
      layout: "admin-layout",
      navigation: "Challenge",
      permission: "admin",
    },
  },
  {
    name: "ChallengeList",
    path: "/admin/challenge/challenge-list",
    component: ChallengeList,
    meta: {
      layout: "admin-layout",
      navigation: "Challenge",
      permission: "admin",
    },
  },
  {
    name: "AdminTraining",
    path: "/admin/training",
    component: AdminTraining,
    meta: {
      layout: "admin-layout",
      navigation: "Training",
      permission: "admin",
    },
  },
  {
    name: "AdminTrainingModule",
    path: "/admin/training/module/:moduleId",
    component: TrainingModule,
    meta: {
      layout: "admin-layout",
      navigation: "Training",
      permission: "admin",
    },
  },
];

const platformRoutes = [
  {
    path: "/platform/plan_sales",
    component: PlanSales,
    meta: { layout: "platform-layout", navigation: "Plan sales" },
  },
  {
    path: "/platform/plan_sales/:id",
    component: PlanSaleDetails,
    meta: { layout: "platform-layout", navigation: "Plan sales" },
  },
  {
    path: "/platform/products/:id",
    component: ProductDetails,
    meta: { layout: "platform-layout", navigation: "Products" },
  },
  {
    path: "/platform/products",
    component: ProductList,
    meta: { layout: "platform-layout", navigation: "Products" },
  },
  {
    path: "/platform/claim_invoices",
    component: StoreClaimInvoices,
    meta: {
      layout: "platform-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/platform/claims",
    component: ClaimList,
    meta: {
      layout: "platform-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/platform/claims/:id",
    component: StoreClaimDetails,
    meta: {
      layout: "platform-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/platform/profile",
    component: Profile,
    meta: { layout: "platform-layout" },
  },
  {
    name: "PlatformContractDistributions",
    path: "/platform/contract-distributions",
    component: ContractDistributions,
    meta: {
      layout: "platform-layout",
      navigation: "Contract Distributions",
    },
  },
  {
    name: "PlatformContractDistributionDetails",
    path: "/platform/contract-distributions/:id",
    component: ContractDistributionDetails,
    meta: {
      layout: "platform-layout",
      navigation: "Contract Distributions",
    },
  },
];

const posRoutes = [
  {
    path: "/pos/home",
    component: Home,
    meta: { layout: "pos-layout", navigation: "Home" },
  },
  {
    path: "/pos",
    redirect: "/pos/home",
  },
  {
    path: "/pos/subscription",
    component: Subscription,
    meta: { layout: "pos-layout", navigation: "Subscription" },
  },
  {
    path: "/pos/leads",
    component: Leads,
    meta: { layout: "pos-layout", navigation: "Leads" },
  },
  {
    path: "/pos/plan-sales",
    component: PlanSales,
    meta: {
      layout: "pos-layout",
      navigation: "Plan sales",
      permission: "plan_sales",
    },
  },
  {
    path: "/pos/plan-sales/:id",
    component: PlanSaleDetails,
    meta: { layout: "pos-layout", navigation: "Plan sales" },
  },
  {
    path: "/pos/claim_invoices",
    component: PosClaimInvoices,
    meta: {
      layout: "pos-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/pos/claims",
    component: ClaimList,
    meta: {
      layout: "pos-layout",
      navigation: "Claim List",
      permission: "claims",
    },
  },
  {
    path: "/pos/claims/:id",
    component: PosClaimDetails,
    meta: {
      layout: "pos-layout",
      navigation: "Claim management",
      permission: "claims",
    },
  },
  {
    path: "/pos/profile",
    component: Profile,
    meta: { layout: "pos-layout" },
  },
  {
    name: "PosSellers",
    path: "/pos/sellers",
    component: SellerList,
    meta: {
      layout: "pos-layout",
      navigation: "Sellers",
    },
  },
  {
    name: "PosCurrentChallenge",
    path: "/pos/challenge/current",
    component: PosCurrentChallenge,
    meta: {
      layout: "pos-layout",
      navigation: "Challenge",
    },
  },
  {
    name: "PosChallengeList",
    path: "/pos/challenge/challenge-list",
    component: PosChallengeList,
    meta: {
      layout: "pos-layout",
      navigation: "Challenge",
    },
  },
  {
    name: "PosRetributions",
    path: "/pos/retributions",
    component: PosRetributions,
    meta: {
      layout: "pos-layout",
      navigation: "Retributions",
    },
  },
  {
    name: "PosRetributionsGrid",
    path: "/pos/retribution-configurations",
    component: PosRetributionsGrid,
    meta: {
      layout: "pos-layout",
      navigation: "Retributions",
    },
  },
  {
    name: "PosContractDistributions",
    path: "/pos/contract-distributions",
    component: ContractDistributions,
    meta: {
      layout: "pos-layout",
      navigation: "Contract Distributions",
    },
  },
  {
    name: "PosContractDistributionDetails",
    path: "/pos/contract-distributions/:id",
    component: ContractDistributionDetails,
    meta: {
      layout: "pos-layout",
      navigation: "Contract Distributions",
    },
  },
  {
    name: "PosPilotage",
    path: "/pos/dashboard",
    component: PosPilotage,
    meta: {
      layout: "pos-layout",
      navigation: "Home",
    },
  },
  {
    path: "/pos/pilotage",
    redirect: "/pos/dashboard",
  },
  {
    name: "PosTraining",
    path: "/pos/training",
    component: PosTraining,
    meta: {
      layout: "pos-layout",
      navigation: "Training",
    },
  },
  {
    name: "Quiz",
    path: "/pos/training/quiz/:quizId",
    component: Quiz,
    meta: {
      layout: "pos-layout",
      navigation: "Training",
    },
  },
  {
    name: "TrainingModule",
    path: "/pos/training/module/:moduleId",
    component: TrainingModule,
    meta: {
      layout: "pos-layout",
      navigation: "Training",
    },
  },
];

const routes = publicRoutes.concat(posRoutes, platformRoutes, adminRoutes);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function needsHttpsRedirection() {
  return (
    (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "demo" || process.env.NODE_ENV === "staging") &&
    location.protocol !== "https:"
  );
}

function redirectHttps() {
  location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

function redirectToDefaultRoute(next) {
  if (store.getters["auth/hasAccessToAdminDashboard"]) {
    next("/admin/home");
  } else if (store.getters["auth/isSeller"] || store.getters["auth/isResponsible"]) {
    next("/pos/home");
  } else {
    next("/signin");
  }
}

function hasPermission(to, userPermissions) {
  return to.meta.permission ? userPermissions.includes(to.meta.permission) : true;
}

router.beforeEach((to, from, next) => {
  if (needsHttpsRedirection()) {
    redirectHttps();
  } else {
    const publicPages = publicRoutes.map((route) => route.path);
    const authRequired = !to.matched.some((matched) => publicPages.includes(matched.path));
    const signedIn = store.state.auth.signedIn;

    // remove isLoading
    store.state.store.isLoading = false;

    if (!authRequired) {
      // Public routes
      next();
      return;
    }

    if (!signedIn || store.state.auth.currentUser.permissions === undefined) {
      // Signin
      next("/signin");
    } else {
      if (to.path === "/") {
        // Default route
        redirectToDefaultRoute(next);
      } else {
        if (!hasPermission(to, store.state.auth.currentUser.permissions)) {
          next(from.path);
        } else {
          if (!to.matched.length) {
            next("/404");
          } else {
            next();
          }
        }
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV === "production" && store.state.auth?.signedIn) {
    identifyPosthogUser(store.state.auth.currentUser);
  }
  next();
});

router.afterEach((to) => {
  const signedIn = store.state.auth?.signedIn;
  if (!signedIn) return;

  // Force reconnect Action Cable on each page navigation
  store.dispatch("cable/forceReconnect");

  if (process.env.NODE_ENV === "production") {
    posthog.capture("$pageview", {
      path: to.fullPath,
      name: to.name,
      layout: to.meta?.layout,
      navigation: to.meta?.navigation,
      activeStoreId: store.getters["store/selectedStoreId"],
    });
  }
});

router;

export default router;
